<template>
    <select class="form-control font-weight-bold text-center" v-model="valor" @change="$emit('evento', valor)">
        <option v-if="local==undefined" value="Todo">Todo</option>
        <option v-if="local" value="">Seleccione Pesonal</option>
        <template v-if="local==undefined">
             <option v-for="d in $store.state.dataPersonal" :key="d.dni" :value="d.dni">{{d.vendedor }}
            
        </option>
        </template>
        <template v-else>
             <option v-for="d in $store.state.dataPersonal" :key="d.idlocal" :value="d.idlocal">{{d.vendedor }}
        </option>
        </template>
       
    </select>
</template>

<script>
    export default {
        name: "SelectPersonal",
        props: ['valor_entrada','local'],
        data() {
            return {
                valor: '',
                data: []
            }
        },
        beforeMount() {
            setTimeout(() => {

                this.valor = this.valor_entrada;
            }, 100);
        },
     
        watch: {

            valor_entrada(newQuestion, oldQuestion) {
                this.valor = newQuestion;

            }
        },
    
    }
</script>